interface Errors {
  [key: string]: Array<string>;
}

export default function parseValidationState(errors: Errors, controlName: string) {
  const capitalizedControlName = controlName.charAt(0).toUpperCase() + controlName.slice(1);
  const errorName = `request.${capitalizedControlName}`;

  return errors?.[errorName]?.[0];
}
